import { action, onUpdate } from "@reatom/framework";
import { urlAtom } from "@reatom/url";
import { RoutesPaths } from "src/routes/RoutesPaths";
import { productSelectionStore } from "src/store/atoms";

import { getProductSampleRequest } from "../../widgets/ProductSamples/store/fetchers/getProductSampleRequest";
import { selectionIdAtom, updateSelectionId } from "./filterQuery";

export const restoreSelectionQuery = action((ctx) => {
  const currentSelection = ctx.get(productSelectionStore.currentSelectionAtom);

  if (!currentSelection || ctx.get(selectionIdAtom) !== undefined) {
    return;
  }

  updateSelectionId(ctx, currentSelection.id, true);
}, "restoreSelectionQuery");

export const syncSelectionFromQuery = action(async (ctx) => {
  const selectionId = ctx.get(selectionIdAtom);
  const currentSelection = ctx.get(productSelectionStore.currentSelectionAtom);

  if (selectionId === currentSelection?.id) {
    return;
  }

  if (selectionId === undefined) {
    productSelectionStore.clearSelectionAction(ctx);

    return;
  }

  const selection = await ctx.schedule(() =>
    getProductSampleRequest(ctx, selectionId),
  );

  productSelectionStore.setCurrentSelectionAction(ctx, selection);
}, "syncSelectionFromQuery");

onUpdate(productSelectionStore.currentSelectionAtom, (ctx, selection) => {
  if (ctx.get(urlAtom).pathname === RoutesPaths.LK.GOODS) {
    updateSelectionId(ctx, selection?.id);
  }
});
